import { supabase } from '../supabaseClient';

/* Bandeaux d'alerte des cartes maintenance cochés « vus » (colonne phases.alertes_vues). */

export function setSeenAlerts(phaseId, seen) {
  return supabase.from('phases').update({ alertes_vues: seen }).eq('id', phaseId);
}
